import {memo, useEffect, useMemo, useState} from 'react'
import {DatatableComponent} from '../../../shared/DatatableComponent/DataTableComponent'
import {useAppDispatch, useAppSelector} from '../../../../hooks'

import {Chip} from 'primereact/chip'
import {
  fetchObjectFamilles,
  getObjectFamilles,
  setSelectedStatus,
} from '../../../Status/slice/status.slice'
import {Dropdown} from 'primereact/dropdown'
import ButtonComponent from '../../../shared/ButtonComponent/ButtonComponent'
import {OlangItem} from '../../../shared/Olang/user-interface/OlangItem/OlangItem'
import {
  fetchFamilles,
  getFamilles,
  getSelectedObject,
  removeFamille,
  setEditFamille,
  setSelectedFamille,
  setSelectedObject,
  setShow,
} from '../../slice/famille.slice'
import {setAlertParams} from '../../../../store/slices/alert.slice'
import {fetchValidator} from '../../../Inventory/slice/inventory.slice'
import {Button} from 'primereact/button'
import { PageHeader } from '../../../shared/PageHeader/PageHeader'
import { DataTableComponent } from '@omniyat/reactcomponents'

const FamilleList = ({titleShow, detailView, familles}) => {
  const [selectedValue, setSelectedValue] = useState({uid: 0, name: '', label: ''})
  const [loading, setLoading] = useState(false)
  const famillesData = useAppSelector(getFamilles)
  const objectFamillesData = useAppSelector(getObjectFamilles)
  const dispatch = useAppDispatch()
  const selectedObject = useAppSelector(getSelectedObject)
  let icon = detailView === 'Detail' ? 'pi-eye' : 'pi-sliders-v'
  let [isFetching, setIsFetching] = useState(false)
  console.log('qqselectedObject', selectedObject)
  useEffect(() => {
    dispatch(fetchObjectFamilles())
  }, [])

  // Sélectionner automatiquement l'objet "Tag" par défaut
  useEffect(() => {
    if (objectFamillesData.length > 0 && !selectedObject) {
      // Chercher l'objet "tag" dans la liste
      const tagObject = objectFamillesData.find(obj => 
        obj.name?.toLowerCase() === 'tag' || 
        obj.label?.toLowerCase().includes('tag')
      )
      
      if (tagObject) {
        console.log('🏷️ Sélection automatique de l\'objet Tag:', tagObject)
        const selectedObj = {
          uid: tagObject.uid,
          name: tagObject.name,
          typeId: tagObject.typesId
        }
        dispatch(setSelectedObject(selectedObj))
        handleFetchFamilles(tagObject)
      } else if (objectFamillesData.length > 0) {
        // Si pas de tag trouvé, sélectionner le premier objet disponible
        const firstObject = objectFamillesData[0]
        console.log('📋 Sélection du premier objet disponible:', firstObject)
        const selectedObj = {
          uid: firstObject.uid,
          name: firstObject.name,
          typeId: firstObject.typesId
        }
        dispatch(setSelectedObject(selectedObj))
        handleFetchFamilles(firstObject)
      }
    }
  }, [objectFamillesData, selectedObject])

  let actions = [
    {
      label: 'Supprimer',
      icon: 'pi pi-trash text-red-500',
      confirm: 'test',
      command: (e) => {
        dispatch(setSelectedFamille(e.item.data))
        dispatch(
          setAlertParams({
            title: 'Supprimer',
            message: 'Voulez-vous vraiment supprimer famille?',
            acceptClassName: 'p-button-danger',
            visible: true,
            accept: () => {
              // Le refresh est déjà géré dans removeFamille slice
              dispatch(removeFamille({currentFamille: e.item.data, type: selectedObject?.name}))
            },
          })
        )
      },
    },
    {
      label: `${detailView}`,
      icon: `pi ${icon} text-blue-500`,
      command: (e) => {
        dispatch(fetchValidator('famille'))
        dispatch(setSelectedFamille(e.item.data))
        dispatch(setShow(false))
      },
    },
  ]
  const colorTemplate = (rowData) => (
    <div
      style={{
        backgroundColor: `${rowData?.bgColor}`,
        color: 'white',
      }}
      className='badge'
    >
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </div>
  )

  const iconTemplate = (rowData) => <i class={`${rowData?.icon} text-2xl`}></i>

  const columns = [
    {
      header: 'Label',
      field: 'label',
      olang: 'label',
    },
    // {
    //   header: 'Type',
    //   olang: 'Type',
    //   field: 'typeLabel',
    // },
    {
      header: 'Color',
      olang: 'Color',
      field: null,
      body: colorTemplate,
    },
    {
      header: 'Icon',
      olang: 'Icon',
      field: 'icon',
      body: iconTemplate,
    },
  ]

  const exportFields = [
    {label: 'Label', column: 'label'},
    // {label: 'Type', column: 'typeLabel'},
    {label: 'Color', column: 'color'},
    {label: 'Icon', column: 'icon'},
  ]

  const dropdownOptions = useMemo(()=>{
    return objectFamillesData.map((o) => ({
      label: o.label,
      code: o.name,
      value: o.uid,
      typesId: o.typesId,
      icon: o.icon,
    }))
  }, [objectFamillesData])

  const handleChange = (e) => {
    console.log('eeeee:', e)
    const selectedOption = dropdownOptions.find((option) => option.value === e.value)
    let obj = {uid: e.value, name: selectedOption.code, typeId: selectedOption.typesId}
    dispatch(setSelectedObject(obj))
    handleFetchFamilles(obj)
  }

  const handleFetchFamilles = (selected) => {
    console.log('famille selected:', selected)
    setLoading(true)
    let selectedObject = {
      uid: selected.value,
      name: selected.code,
      typeId: selected.typesId,
    }
    dispatch(setSelectedObject(selectedObject))
    dispatch(fetchFamilles({src: selected.code})).then((res) => {
      setLoading(false)
    })
  }

  let create = () => {
    dispatch(fetchValidator('famille')).then(() => {
      dispatch(setEditFamille(true))
      dispatch(setSelectedFamille(null))
    })
  }

  useEffect(() => {
    if(dropdownOptions[0]){
      handleFetchFamilles(dropdownOptions[0])
    }
  }, [dropdownOptions])
  return (
    <>
      {/* Page Header */}
      <PageHeader
        titleOlang="famille.list"
        backPath="/dashboard"
        info={
          <div className="flex align-items-center gap-3">
            {selectedObject && (
              <div className="flex align-items-center gap-2">
                <i className="pi pi-tag text-xl text-primary"></i>
                <span className="text-lg font-semibold">{selectedObject.name}</span>
              </div>
            )}
            {famillesData && famillesData.length > 0 && (
              <>
                <div className="border-left-2 border-300" style={{ height: '30px' }}></div>
                <div className="flex align-items-center gap-2">
                  <i className="pi pi-list text-xl text-primary"></i>
                  <span className="text-lg font-semibold">
                    {famillesData.length} famille{famillesData.length > 1 ? 's' : ''}
                  </span>
                </div>
              </>
            )}
          </div>
        }
        className="m-3"
      />
      <div className='card shadow-2 bg-gray-50 mt-2 p-2 mb-3'>
        <p className='text-xl pt-3 pl-3'>
          <OlangItem olang={'object'} />
        </p>

       

        <div className='flex gap-3 ml-3 w-full flex-row my-3'>
          {Array.isArray(dropdownOptions) &&
            dropdownOptions?.map((o) => (
              <Button
                key={o.value}
                outlined
                loading={o.value === selectedObject?.uid && loading}
                disabled={o.value === selectedObject?.uid || loading}
                icon={'fa fa-sharp-duotone fa-solid' + o.icon}
                severity={o.value === selectedObject?.uid ? 'success' : 'secondary'}
                className={`flex align-items-center w-10rem text-lg font-bold gap-2 `}
                onClick={() => handleFetchFamilles(o)}
              >
                {o.label}
              </Button>
            ))}
        </div>
      </div>
      <DataTableComponent
        tableId='familles-table'
        data={selectedObject ? famillesData : []}
        columns={columns}
        exportFields={exportFields}
        onSelections={(r) => console.log('data:', r)}
        onNew={selectedObject ? create : []}
        rowActions={actions}
      />
    </>
  )
}

export default memo(FamilleList)
